import checkFormat from '@/utils/checkFormat'
import { Dialog, Toast } from 'vant'
import formattingPriceData from '@/utils/formattingPriceData.js'
import api from '@/api/api.js'
import { taxationTypes, estimatesList } from '@/utils/const.js'

export const newQuoteMixin = {
  data() {
    return {}
  },
  methods: {
    submitYzm() {
      if (this.answer) {
        this.answer = this.answer.replace(/\s+/g, '')
      }
      if (this.answerCI) {
        this.answerCI = this.answerCI.replace(/\s+/g, '')
      }
      let add
      if (this.switchValue && this.alter) {
        if (this.basePart.renewalFlagCI === '1' && this.basePart.renewalFlag === '1') {
          add = {
            demandNo: this.basePart.demandNo,
            demandNoCI: this.basePart.demandNoCI,
            answer: this.answer,
            answerCI: this.answerCI
          }
        } else if (this.basePart.renewalFlagCI === '1' && this.basePart.renewalFlag === '0') {
          add = {
            demandNo: '',
            demandNoCI: this.basePart.demandNoCI,
            answer: '',
            answerCI: this.answerCI
          }
        } else if (this.basePart.renewalFlagCI === '0' && this.basePart.renewalFlag === '1') {
          add = {
            demandNo: this.basePart.demandNo,
            demandNoCI: '',
            answer: this.answer,
            answerCI: ''
          }
        }
      } else if (this.switchValue && this.alter === false) {
        add = {
          demandNo: this.basePart.demandNo,
          demandNoCI: '',
          answer: this.answerCI,
          answerCI: ''
        }
      } else if (this.switchValue === false && this.alter) {
        add = {
          demandNo: this.basePart.demandNo,
          demandNoCI: '',
          answer: this.answer,
          answerCI: ''
        }
      }
      this.isFixed = false
      checkFormat.SolveThrough(false)
      this.baoJia(add)
    },
    Changes(i) {
      // 选择险种
      this.price = false
      this.$store.commit('setAlter', '3')
      if (this.insurance[i].kindCode === 'D4') {
        this.insurance[i].seatCount = this.actulResult.seatCount - 1
        if (this.insurance[i].unitAmount.text !== '0' && this.insurance[i].unitAmount.text !== '') {
          this.insurance[i].amount = checkFormat.numMulti(checkFormat.numMulti(Number(this.insurance[i].unitAmount.text), Number(this.actulResult.seatCount - 1)), 10000) + ''
        } else {
          this.insurance[i].amount = '0'
        }
      }
      let num = 0
      this.insurance[i].values = !this.insurance[i].values
      if (!this.insurance[i].values) {
        this.insurance[i].accessoryRisk.forEach(item => {
          item.values = false
        })
      }

      for (let k = 0; k < this.insurance.length; k++) {
        if (this.insurance[k].values === false) {
          num++
        }
      }
      if (num === this.insurance.length) {
        this.alter = false
      }
    },
    onConfirms(value) {
      this.price = false
      this.$store.commit('setAlter', '3')
      if (this.dropDownKey === 1) {
        this.insurance.forEach((item, index) => {
          if (item.kindCode === this.index) {
            if (item.kindCode === 'A') {
              item.value = value
            } else {
              item.amount = value
              if (item.kindCode === 'B') {
                item.accessoryRisk.forEach(kind => {
                  if (kind.kindCode === 'B2') {
                    kind.amount = value.code
                  }
                })
              }
            }
          } else {
            item.accessoryRisk.forEach(kind => {
              if (kind.kindCode === this.index) {
                kind.excessText === '免赔率' ? kind.deductibleRate = value : kind.amount = value
              }
            })
          }
        })
      } else {
        this.moreServeData.forEach(item => {
          if (item.kindCode === this.index) {
            item.serviceTimes = value
          }
        })
      }
      this.popupVisibles = false
    },
    onConfirm4(value) {
      this.price = false
      this.$store.commit('setAlter', '3')
      this.taxRelifInfo = {
        extendChar2: '',
        taxComName: '',
        hfCode: value.code,
        paidFreeCertificate: '',
        taxDocumentDate: '',
        SumPayTax: '',
        taxPaidAreaCode: '',
        taxComCode: ''
      }
      if (this.$store.state.carShipTax.taxPaidAreaCode && this.$store.state.carShipTax.taxPaidAreaCode !== '') {
        this.region.forEach(el => {
          if (el.codeCode === this.$store.state.carShipTax.taxPaidAreaCode) {
            this.taxPaidAreaCode = el.codecname
            this.taxRelifInfo.taxPaidAreaCode = el.codeCode
          }
        })
      } else {
        this.region.forEach(EL => {
          if (EL.codeCode === this.$store.state.proposalAreaCode) {
            this.taxPaidAreaCode = EL.codecname
            this.taxRelifInfo.taxPaidAreaCode = EL.codeCode
          }
        })
      }
      this.taxRelifFlagnae = value.text
      this.demonstrate = false
    },
    // 产品方案选择器 确认方案的函数
    onConfirm(value) {
      this.isGuangDong = false
      this.insuranceList.forEach(item => {
        if (item.productCode === this.status) {
          item.attachRiskListParam.planName = item.productPlanDTOList[value.code].projectName
          item.attachRiskListParam.planCode = item.productPlanDTOList[value.code].projectCode
          item.attachRiskListParam.riskCode = item.productPlanDTOList[value.code].riskCode
          item.attachRiskListParam.commiFee = item.productPlanDTOList[value.code].commiFee
          item.attachRiskListParam.sumAmount = item.productPlanDTOList[value.code].sumAmount
          item.attachRiskListParam.sumPremium = item.productPlanDTOList[value.code].sumPremium
          // 如果是动态计算保费，不能直接item.sumPremium=item.scheme.sumPremium ！！！
          item.sumPremium = item.attachRiskListParam.sumPremium
        }
      })
      // 选中广东方案，才显示驾乘投保份数
      if (this.insuranceList[0].scheme.code.substr(0, 3) === '244') {
        this.isGuangDong = true
      }
      this.popupVisible = false
    },
    filtration(value) {
      return value < 10 ? '0' + value : value
    },
    // 是否续保选择器 确定函数
    onXuBconfirm(value) {
      this.insuranceList.forEach(item => {
        if (item.productCode === this.status) {
          if (Number(value.code) === 1) {
            const data = {
              identifyNumber: this.$store.state.recognizeeIn.identifyNumber,
              productCode: item.productCode
            }
            this.$http.post(api.XuBaoFastRenewal, data).then(res => {
              if (res.data.rtnCode === '0000') {
                item.conditionParam.isXuBaoText = '是'
                item.conditionParam.isXuBaoCode = '1'
              } else {
                item.conditionParam.isXuBaoText = '否'
                item.conditionParam.isXuBaoCode = 0
                this.isXuBao = true
              }
            })
          } else {
            item.conditionParam.isXuBaoText = '否'
            item.conditionParam.isXuBaoCode = 0
          }
        }
      })
      this.popupXBVisible = false
    },
    // 车辆实际价值
    realValueJQ(date) {
      const data = {
        carKindCode: this.actulResult.carKindCode, // 车辆种类代码
        enrollDate: this.actulResult.enrollDate, // 注册日期
        purchasePrice: this.actulResult.purchasePrice, // 新车购置价
        seatCount: this.actulResult.seatCount, // 座位数
        startDate: date, // 商业险起期
        tonCount: this.actulResult.tonCount,
        useNatureCode: this.actulResult.useNatureCode
      }
      this.$http.post(api.getActualValue, data).then(res => {
        if (res.data.rtnCode === '0000') {
          this.actualValue = res.data.actualValue
          this.insurance.forEach(item => {
            if (item.kindCode === 'A' || item.kindCode === 'G' || item.kindCode === 'Z') {
              item.amount = res.data.actualValue
              // 2021-06-24 所有车辆得车损保额，均取值为“约定车辆价值”
              this.amounts = !res.data.agreeActualValue ? res.data.actualValue : res.data.agreeActualValue
            }
          })
          this.JQinsurance.amount = res.data.actualValue
          this.$store.state.vehicleInfos.actualValue = res.data.actualValue
        } else {
          Toast(res.data.rtnMsg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    newChoiceModel() {
      this.carModel = false
      this.newBaoJia()
    },
    choiceModel() {
      if (this.parameters.vehicleInfo.platVehicleCode === this.carModelList[this.carModelIndex].vehicleCode) {
        // this.carModel = false
        this.price = true
        // 当用户手动录入的定价系数的前提下，通过费折联动计算后，导致费用低于0时，进行提示，并以系统返回的系数自动覆盖“自主定价系数录入值”，并自动按系统返回系数报价
        if (this.underwriting.profitRate && this.underwriting.profitRate !== this.uwRel) {
          Dialog.alert({
            message: `您录入的自主定价系数【${this.underwriting.profitRate}】不在定\n价有效范围内！\n定价系统返回的自主定价系数为【${this.uwRel}】，已按照返回值为您自动报价`,
            confirmButtonColor: '#5e2589',
            confirmButtonText: '知道了'
          }).then(() => {
            // 将返回值覆盖用户输入值
            this.underwriting.profitRate = this.uwRel
            if (this.basePart.messagePrice) {
              Dialog.alert({
                message: this.basePart.messagePrice,
                confirmButtonColor: '#5e2589'
              }).then(() => {
              })
            }
          })
        } else {
          //  费折联动弹框
          if (this.basePart.messagePrice) {
            Dialog.alert({
              message: this.basePart.messagePrice,
              confirmButtonColor: '#5e2589'
            }).then(() => {
            })
          }
        }
      } else {
        this.switchs = true
        const exactParame = JSON.parse(JSON.stringify(this.parameters))
        exactParame.vehicleInfo.platVehicleCode = this.carModelList[this.carModelIndex].vehicleCode
        this.$http.post(api.calculateInsuredFee, exactParame).then(res => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            this.switchs = false
            this.$store.commit('setVariation', false)
            this.$store.commit('setBaseInfo', this.parameters.baseInfo)
            if (res.data.resultObj.pricingList.length !== 0) {
              this.underwritingProfitRate = res.data.resultObj.pricingList[0].jYUwrel // 核保系数
            }
            if (res.data.resultObj && res.data.resultObj.basePart) {
              //  费折联动
              if (res.data.resultObj.basePart.messagePrice) {
                this.basePart.messagePrice = res.data.resultObj.basePart.messagePrice
              }
              // 真单交
              if (!checkFormat.isEmpty(res.data.resultObj.basePart.isDjq)) {
                this.basePart.isDjq = res.data.resultObj.basePart.isDjq
                this.basePart.isDjqText = res.data.resultObj.basePart.isDjq === '0' ? '否' : '是'
                this.basePart.isDjqShow = true
              } else {
                this.basePart.isDjqShow = false
              }
            }
            const adds = ['extendChar2', 'taxComName', 'taxRelifFlag', 'paidFreeCertificate', 'taxDocumentDate', 'sumPayTax', 'taxPaidAreaCode', 'taxComCode']
            adds.forEach((addEl, index) => {
              if (Object.prototype.hasOwnProperty.call(res.data.resultObj.carShipTax, addEl) && res.data.resultObj.carShipTax[addEl] !== null && res.data.resultObj.carShipTax[addEl] !== '') {
                if (addEl === 'taxRelifFlag') {
                  this.taxRelifFlagnae = taxationTypes[checkFormat.subtract(Number(res.data.resultObj.carShipTax[addEl]), 1)].text
                  this.taxRelifInfo.hfCode = res.data.resultObj.carShipTax[addEl]
                } else {
                  if (res.data.resultObj.carShipTax.taxRelifFlag !== '4') {
                    this.taxRelifInfo[addEl] = res.data.resultObj.carShipTax[addEl]
                  }
                }
              }
            })
            const lastYearPolicyInfo = res.data.resultObj.lastYearPolicyInfo
            let counter = 0
            for (var value in lastYearPolicyInfo) {
              if (lastYearPolicyInfo[value] !== '' && lastYearPolicyInfo[value] !== undefined && lastYearPolicyInfo[value] !== null) {
                counter++
              }
              this[value] = lastYearPolicyInfo[value]
            }
            if (counter !== 0) {
              if (lastYearPolicyInfo.lastEndDate !== '') {
                const dataStr = (this.SYStartDate + ((this.SYStartHour && this.SYStartMinute) ? (' ' + this.SYStartHour + ':' + this.SYStartMinute) : '')).replace(/-/g, '/')
                const data = new Date(dataStr).getTime()
                const datas = new Date(lastYearPolicyInfo.lastEndDate.replace(/-/g, '/')).getTime()
                const now = new Date().getTime()
                if ((!Number.isNaN(data)) && (!Number.isNaN(datas)) && data > datas && datas > now) {
                  this.showConfirm = true
                  this.joinSy = true
                } else if (data !== datas) {
                  this.decide = true
                }
              }
              if (lastYearPolicyInfo.lastEndDateCI !== '') {
                const dataStr = (this.JQStartDate + ((this.JQStartHour && this.JQStartMinute) ? (' ' + this.JQStartHour + ':' + this.JQStartMinute) : '')).replace(/-/g, '/')
                const data = new Date(dataStr).getTime()
                const datas = new Date(lastYearPolicyInfo.lastEndDateCI.replace(/-/g, '/')).getTime()
                const now = new Date().getTime()
                if ((!Number.isNaN(data)) && (!Number.isNaN(datas)) && data > datas && datas > now) {
                  this.showConfirmCI = true
                  this.joinJq = true
                } else if (data !== datas && !this.showConfirm) {
                  this.decideCI = true
                }
              }
            }

            if (this.alter) {
              this.ciProfitDetailData = res.data.resultObj.ciProfitDetailData
            }
            this.SumPayTax = res.data.resultObj.carShipTax.sumPayTax === null ? '0.00' : res.data.resultObj.carShipTax.sumPayTax
            if (res.data.resultObj.basePart.discount && res.data.resultObj.basePart.discount !== '') {
              this.discount = res.data.resultObj.basePart.discount
            } else if (res.data.resultObj.basePart.discount === '' || res.data.resultObj.basePart.discount === null) {
              this.discount = '0.00'
            }
            // 加 驾乘私家车意外险 的保费
            if (this.isShowSJY) {
              this.sumPremium = checkFormat.plus(checkFormat.numDiv(Math.floor(checkFormat.numMulti(Number(res.data.resultObj.basePart.sumPremium), 100)), 100), Number(this.scheme.sumPremium))
            } else {
              this.sumPremium = checkFormat.numDiv(Math.floor(checkFormat.numMulti(Number(res.data.resultObj.basePart.sumPremium), 100)), 100) // 总保费
            }
            // totals动态总保费
            this.totals = checkFormat.numDiv(Math.floor(checkFormat.numMulti(Number(res.data.resultObj.basePart.sumPremium), 100)), 100)
            if (res.data.resultObj.pricingList !== null && res.data.resultObj.pricingList.length > 0) {
              this.pricingScore = res.data.resultObj.pricingList[0].rev_PredScore
              this.revPredScoreAdjust = res.data.resultObj.pricingList[0].revPredScoreAdjust
              this.ncdBpremELR = res.data.resultObj.pricingList[0].ncdBpremELR
              this.lrRecom = res.data.resultObj.pricingList[0].lr_Recom
              this.lrReComAdjust = res.data.resultObj.pricingList[0].lrReComAdjust
            }
            if (this.alter === false) {
              this.SYpremium = '0.00'
            } else {
              res.data.resultObj.planList.forEach(item => {
                if (item.planText === '商业险保费合计') {
                  this.SYpremium = item.planFee
                }
              })
            }
            res.data.resultObj.handlingFeeList.forEach(item => {
              if (item.dataType === 'CI') {
                this.JQhandlingFee = item.handlingFeeExcludingTax
              }
              if (item.dataType === 'BI') {
                this.SYhandlingFee = item.handlingFeeExcludingTax
              }
            })
            let sign = 0
            res.data.resultObj.itemKindList.forEach(itemEl => {
              this.insurance.forEach(item => {
                if (item.kindCode === itemEl.kindCode) {
                  item.premium = itemEl.premium
                } else {
                  item.accessoryRisk.forEach(kind => {
                    if (kind.kindCode === itemEl.kindCode) {
                      kind.premium = itemEl.premium
                    }
                  })
                }
              })
              this.moreServeData.forEach(item => {
                if (item.kindCode === itemEl.kindCode) {
                  item.premium = itemEl.premium
                }
              })
              if (itemEl.kindCode === 'BZ') {
                this.plusPremium = itemEl.premium
                sign++
              }
              if (itemEl.kindCode === 'B') {
                this.JQinsurance.premium = itemEl.premium
              }
            })
            if (sign === 0) {
              this.JQPremium = '0.00'
            }
            if (counter === 0) {
              Toast.success(res.data.rtnMsg)
            }
            this.hisClaimList = res.data.resultObj.hisClaimList
            this.illegalInfoList = res.data.resultObj.illegalInfoList
            this.already = true
            this.price = true
            this.carModel = false
          } else {
            this.switchs = false
            Toast.clear()
            this.frame = true
            checkFormat.SolveThrough(true)
            this.analysis = res.data.rtnMsg
            if (res.data.resultObj && res.data.resultObj.carShipTax) {
              const adds = ['extendChar2', 'taxComName', 'taxRelifFlag', 'paidFreeCertificate', 'taxDocumentDate', 'sumPayTax', 'taxPaidAreaCode', 'taxComCode']
              adds.forEach((addEl, index) => {
                if (Object.prototype.hasOwnProperty.call(res.data.resultObj.carShipTax, addEl) && res.data.resultObj.carShipTax[addEl] !== null && res.data.resultObj.carShipTax[addEl] !== '') {
                  if (addEl === 'taxRelifFlag') {
                    this.taxRelifFlagnae = taxationTypes[checkFormat.subtract(Number(res.data.resultObj.carShipTax[addEl]), 1)].text
                    this.taxRelifInfo.hfCode = res.data.resultObj.carShipTax[addEl]
                  } else {
                    if (res.data.resultObj.carShipTax.taxRelifFlag !== '4') {
                      this.taxRelifInfo[addEl] =
                        res.data.resultObj.carShipTax[addEl]
                    }
                  }
                }
              })
            }
            this.carModel = false
          }
        })
      }
    },
    // 报价
    async baoJia(val) {
      if (this.switchValue === false && this.alter === false) {
        this.$toast('请选择险种信息')
        return false
      }
      let label = 0
      this.insurance.forEach(item => {
        if (item.values === true) {
          label++
        }
      })
      if (this.alter === true && label === 0) {
        this.$toast('请选择商业险险种')
        return false
      }
      // 若用户没有填写约定车辆价值----->约定车辆价值就取实际车辆价值
      if (!this.agreeActualValue) {
        this.agreeActualValue = this.actualValue
        this.amounts = this.actualValue
      }
      const floatPoastion = String(this.agreeActualValue).indexOf('.') + 1
      const floatTotle = String(this.agreeActualValue).length - floatPoastion
      if (!Number(this.agreeActualValue)) {
        this.$toast('约定车辆价值只能为数字')
        return false
      }
      if (Number(this.agreeActualValue) && floatPoastion > 0 && floatTotle > 2) {
        this.$toast('约定车辆价值只支持两位小数')
        return false
      }
      if (this.switchValue === true) {
        if (this.taxRelifInfo.hfCode !== '4' && this.taxRelifInfo.hfCode !== '1' && this.taxRelifInfo.hfCode !== '5') {
          if (this.taxRelifInfo.extendChar2 === '' || this.taxRelifInfo.extendChar2 === undefined || this.taxRelifInfo.extendChar2 === null) {
            this.$toast('减免税凭证号不能为空')
            return false
          }
          if (this.taxRelifInfo.taxComName === '' || this.taxRelifInfo.taxComName === undefined || this.taxRelifInfo.taxComName === null) {
            this.$toast('开具凭证的税务机关名称不能为空')
            return false
          }
        }
        if (this.taxRelifInfo.hfCode === '4') {
          const estimates = estimatesList
          const indexs = []
          estimates.forEach((value, index) => {
            if (this.taxRelifInfo[value.value] === '' || this.taxRelifInfo[value.value] === undefined || this.taxRelifInfo[value.value] === null) {
              indexs.push(index)
            }
          })
          if (indexs.length !== 0) {
            this.$toast(estimates[indexs[0]].name + '不能为空')
            return false
          }
        }
      }
      const deductibleRateRisk = 'FA,FB,FD3,FD4'
      const amountRisk = 'L,R1,S1,R2,'
      const inputRisk = 'D2,S2,R3,S3'
      const unitAmountRisk = 'D3, D4'
      const selectRiskNum = 0
      if (this.alter) {
        for (let i = 0; i < this.insurance.length; i++) {
          if (this.insurance[i].values) {
            if (unitAmountRisk.indexOf(this.insurance[i].kindCode) > -1 && !this.insurance[i].unitAmount.code) {
              this.$toast(`请输入${this.insurance[i].kindName}保额`)
              return false
            } else {
              for (let k = 0; k < this.insurance[i].accessoryRisk.length; k++) {
                if (this.insurance[i].accessoryRisk[k].values) {
                  if (this.insurance[i].accessoryRisk[k].layoutStyle === '1') {
                    if (deductibleRateRisk.indexOf(this.insurance[i].accessoryRisk[k].kindCode) > -1 && !this.insurance[i].accessoryRisk[k].deductibleRate.code) {
                      this.$toast(`请选择${this.insurance[i].accessoryRisk[k].kindName}免赔率`)
                      return false
                    } else if (amountRisk.indexOf(this.insurance[i].accessoryRisk[k].kindCode) > -1 && !this.insurance[i].accessoryRisk[k].amount.code) {
                      this.$toast(`请选择${this.insurance[i].accessoryRisk[k].kindName}保额`)
                      return false
                    }
                  } else {
                    if (inputRisk.indexOf(this.insurance[i].accessoryRisk[k].kindCode) > -1 && !this.insurance[i].accessoryRisk[k].amount) {
                      this.$toast(`请输入${this.insurance[i].accessoryRisk[k].kindName}保额`)
                      return false
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (this.switchServe) {
        for (let j = 0; j < this.moreServeData.length; j++) {
          if (this.moreServeData[j].values) {
            if (selectRiskNum === this.insurance.length) {
              this.$toast('请选择任一主险')
              return false
            } else {
              if (this.moreServeData[j].layoutStyle === '1') {
                if (!this.moreServeData[j].serviceTimes.code) {
                  this.$toast(`请选择${this.moreServeData[j].kindName}服务次数`)
                  return false
                }
              } else {
                if (!this.moreServeData[j].serviceTimes) {
                  this.$toast(`请输入${this.moreServeData[j].kindName}服务次数`)
                  return false
                }
              }
            }
          }
        }
      }

      if (this.checkInputNum(this.underwriting.profitRate, this.underwriting.maxProfitRate, this.underwriting.minProfitRate) === false) {
        if (this.underwriting.profitRate) {
          this.$toast('输入的自主定价系数必须是在' + this.underwriting.profitRates + '之间且小数点后不超过5位')
          return false
        }
      }
      if (!this.addressFlag.jiaCai) {
        this.$toast('请填写被保家庭财产地址并精确到门牌号')
        return false
      }
      if (!this.addressFlag.ranQi) {
        this.$toast('请填写使用燃气家庭地址并精确到门牌号')
        return false
      }
      // 全面保障数据
      const baozhangData = this.$refs.baozhang.validata()
      const attachRiskList = []
      const carPolicySubInfoList = []
      baozhangData.forEach(ele => {
        if (ele.flag) {
          if (ele.sourceFlag === '1') {
            ele.attachRiskListParam.startDate = this.startTime.split(' ')[0]
            ele.attachRiskListParam.riskCode = ele.riskCode
            attachRiskList.push(ele.attachRiskListParam)
          } else {
            const carPolicySubInfoListParam = {
              address: ele.address,
              quantity: ele.attachRiskListParam.sumQuantity,
              riskCode: ele.riskCode, // 险种代码
              riskName: ele.attachRiskListParam.planName, // 方案名
              insureGradeNo: ele.attachRiskListParam.planCode, // 方案号
              productCode: ele.productCode, // 产品名称
              productName: ele.productName, // 产品代码
              sumAmount: ele.attachRiskListParam.sumAmount,
              sumPremium: ele.attachRiskListParam.sumPremium
            }
            carPolicySubInfoList.push(carPolicySubInfoListParam)
          }
        }
      })
      if (this.quoteRadio === '2' && !this.underwriting.profitRate) {
        this.$toast('请输入自主定价系数，或选择用建议自主定价系数')
        return false
      }
      // this.adds += 1
      if (this.isChange) {
        this.isChange = false
      }
      // 青岛税务登记证号  8aaa6c1f7be90831017bed22cf820331
      if (this.isQD && !this.taxRelifInfo.taxRegistryNumber) {
        const taxNum = await this.getTaxRegistryNumber()
        if (!taxNum) {
          return false
        }
      }
      const insuranceArr = this.switchServe ? this.insurance.concat(this.moreServeData) : this.insurance
      const UserInfo = JSON.parse(localStorage.getItem('setPersonUserInfo'))
      const obj = {
        carPolicySubInfoList: carPolicySubInfoList, // 线下数据处理
        attachRiskList: attachRiskList, // 线上数据处理
        insurance: insuranceArr, // 商业险数据
        JQinsurance: this.JQinsurance, // 交强险数据
        JQstatus: this.switchValue, // 交强险状态
        alter: this.alter, // 商业险状态
        baseInfo: {
          startDateCI: this.JQStartDate,
          endDateCI: this.JQEndDate,
          startHourCI: this.JQStartHour,
          endHourCI: this.JQEndHour,
          startDate: this.SYStartDate,
          endDate: this.SYEndDate,
          startHour: this.SYStartHour,
          endHour: this.SYEndHour,
          startMinute: this.SYStartMinute,
          endMinute: this.SYEndMinute,
          startMinuteCI: this.JQStartMinute,
          endMinuteCI: this.JQEndMinute,
          calculateFlag: this.calculateFlag,
          cityCode: this.$store.state.proposalCityCode,
          provinceCode: this.$store.state.proposalAreaCode
        },
        vehicleInfo: this.actulResult, // 车辆信息
        carOwnerInfo: this.$store.state.carOwnerInfo, // 车主信息
        channel: this.channel,
        underwriting: this.underwriting,
        orderId: this.$store.state.orderId,
        taxRelifInfo: this.taxRelifInfo
      }
      if (!this.switchValue) {
        obj.baseInfo.startDateCI = obj.baseInfo.endDateCI = obj.baseInfo.endHourCI = obj.baseInfo.startHourCI = obj.baseInfo.startMinuteCI = obj.baseInfo.endMinuteCI = ''
      }
      if (!this.alter) {
        obj.baseInfo.startDate = obj.baseInfo.endDate = obj.baseInfo.endHour = obj.baseInfo.startHour = obj.baseInfo.startMinute = obj.baseInfo.endMinute = ''
      }
      const data = formattingPriceData(obj, val) // 通过formattingPriceData方法将数据格式化
      if (data.profitDataList.length !== 0 && this.sign === 1) {
        data.profitDataList.push(this.PayFor)
        data.profitDataList.push(this.Traffic)
      }
      const parameter = {
        attachRiskList: data.attachRiskList,
        carPolicySubInfoList: data.carPolicySubInfoList,
        baseInfo: data.baseInfo,
        carOwnerInfo: data.carOwnerInfo,
        insuredList: this.$store.state.insuredList,
        orderId: data.orderId,
        profitDataList: data.profitDataList,
        vehicleInfo: data.vehicleInfo,
        itemKindList: data.itemKindList,
        taxRelifInfo: data.taxRelifInfo,
        terminalId: localStorage.getItem('setTerminalId'),
        orderOrigin: localStorage.getItem('setChannelCode'),
        channelCode: localStorage.getItem('setChannelCode'),
        proposalAreaCode: this.$store.state.proposalAreaCode,
        proposalCityCode: this.$store.state.proposalCityCode,
        terminalIdType: checkFormat.getPhoneLike()
      }
      parameter.vehicleInfo.agreeActualValue = this.agreeActualValue
      parameter.vehicleInfo.actualValue = this.actualValue
      if (parameter.vehicleInfo.chgOwnerFlag === '0') {
        parameter.vehicleInfo.makeDate = ''
      }
      if (this.$store.state.baseInfo.networkCode && this.$store.state.baseInfo.networkCode !== '') {
        parameter.baseInfo.networkCode = this.$store.state.baseInfo.networkCode
      }
      if (this.$store.state.baseInfo.networkName && this.$store.state.baseInfo.networkName !== '') {
        parameter.baseInfo.networkName = this.$store.state.baseInfo.networkName
      }
      if (this.$store.state.userCode !== null && this.$store.state.userCode !== '') {
        parameter.baseInfo.introduceCode = this.$store.state.userCode
      }
      if (this.$store.state.userName !== null && this.$store.state.userName !== '') {
        parameter.baseInfo.introduceName = this.$store.state.userName
      }
      if (this.$store.state.introduceAgreementNo !== null && this.$store.state.introduceAgreementNo !== '') {
        parameter.baseInfo.introduceAgreementNo = this.$store.state.introduceAgreementNo
      }
      if (this.$store.state.baseInfo.salesPerson) {
        parameter.baseInfo.salesPerson = this.$store.state.baseInfo.salesPerson
      }
      if (this.$store.state.baseInfo.professionalNum) {
        parameter.baseInfo.professionalNum = this.$store.state.baseInfo.professionalNum
      }
      this.parameters = parameter
      const modelObj = {
        basePart: {
          channelCode: localStorage.getItem('setChannelCode'),
          comCode: UserInfo.salesmanInfoDto.comCode,
          exhaustScale: this.actulResult.exhaustCapacity
        },
        carModel: {
          carName: '', // 车款名称
          effectiveDate: this.JQStartDate, // 起保日期
          engineNo: this.actulResult.engineNo, // 发动机号
          expireDate: this.SYEndDate, // 终保日期
          firstRegisterDate: this.actulResult.enrollDate, // 车辆初始登记日期
          licensePlateNo: this.actulResult.licenseNo, // 车牌号码
          licensePlateType: this.actulResult.licenseKindCode, // 号牌种类代码
          modelCode: this.actulResult.platVehicleCode, // 行业车型编码
          motorTypeCode: this.actulResult.carKindCode, // 车辆种类代码
          motorUsageTypeCode: this.actulResult.useNatureCode, // 使用性质代码
          noticeType: '', // 公告型号
          ratedPassengerCapacity: this.actulResult.seatCount, // 核定载客人数
          replacementValue: this.actulResult.purchasePrice, // 新车置购价
          tonnage: Number(this.actulResult.tonCount) / 1000, // 核定载质量(千克)
          vin: this.actulResult.vINNo // 车架号
        }
      }
      this.adds += 1
      this.$http.post(api.pureRiskPremium, modelObj).then(pureRes => {
        if (pureRes.data.rtnCode === '0000') {
          const carModelListT = pureRes.data.carModelList
          if (carModelListT.length > 0) {
            this.carModel = true
            for (const keys in carModelListT) {
              carModelListT[keys].active = false
              carModelListT[0].active = true
              this.carModelIndex = 0
              this.carModelList = carModelListT
            }
          } else if (carModelListT.length === 0) {
            this.price = true
            this.newBaoJia()
          }
        } else {
          this.$toast(pureRes.data.rtnMsg)
        }
        this.adds = this.adds - 1
      }).catch(err => {
        console.log(err)
        this.adds = this.adds - 1
      })
    },
    newBaoJia() {
      this.adds += 1
      this.$http.post(api.calculateInsuredFee, this.parameters).then(res => {
        Toast.clear()
        if (res.data.rtnCode === '0000') {
          this.$store.commit('setVariation', false)
          this.$store.commit('setBaseInfo', this.parameters.baseInfo)
          if (res.data.resultObj && res.data.resultObj.basePart) {
            // 费折联动判断
            if (res.data.resultObj.basePart.messagePrice) {
              this.basePart.messagePrice = res.data.resultObj.basePart.messagePrice
            }
            // 真单交判断
            if (!checkFormat.isEmpty(res.data.resultObj.basePart.isDjq)) {
              this.basePart.isDjq = res.data.resultObj.basePart.isDjq
              this.basePart.isDjqText = res.data.resultObj.basePart.isDjq === '0' ? '否' : '是'
              this.basePart.isDjqShow = true
            } else {
              this.basePart.isDjqShow = false
            }
          }
          // 根据费折联动的最低折扣限制，控制自主定价系数最小值
          if (res.data.resultObj.pricingList && res.data.resultObj.pricingList.length > 0) {
            this.uwRel = res.data.resultObj.pricingList[0].uw_Rel
          }
          // 过户车判断
          if (res.data.resultObj.ciInsureDemandDto) {
            const nowDate = new Date().getTime()
            const issueDateStr = new Date(this.parameters.vehicleInfo.issueDate).getTime()
            //  满足过户车标准，则不允许用户修改过户车标志
            if (res.data.resultObj.ciInsureDemandDto.chgOwnerFlag === '1' && (nowDate - issueDateStr) <= 60 * 60 * 24 * 365 * 1000) {
              this.parameters.vehicleInfo.chgOwnerFlag = '1'
              const carInfo = this.$store.state.vehicleInfos
              carInfo.chgOwnerFlag = '1'
              this.$store.commit('setVehicleInfo', carInfo)
              this.$store.commit('setGuohuFlag', '1')
              if (!this.parameters.vehicleInfo.makeDate) {
                this.$toast('过户车辆请在基础信息页选择用户登记日期')
              } else {
                this.dealWithDate(res)
              }
            } else {
              this.dealWithDate(res)
            }
          }
        } else if (res.data.rtnCode === '9980') {
          this.basePart = res.data.resultObj.basePart
          this.isFixed = true
          checkFormat.SolveThrough(true)
        } else {
          Toast.clear()
          this.frame = true
          checkFormat.SolveThrough(true)
          this.analysis = res.data.rtnMsg
          if (res.data.resultObj && res.data.resultObj.carShipTax) {
            const adds = ['extendChar2', 'taxComName', 'taxRelifFlag', 'paidFreeCertificate', 'taxDocumentDate', 'sumPayTax', 'taxPaidAreaCode', 'taxComCode']
            adds.forEach((value, index) => {
              if (Object.prototype.hasOwnProperty.call(res.data.resultObj.carShipTax, value) && res.data.resultObj.carShipTax[value] !== null && res.data.resultObj.carShipTax[value] !== '') {
                if (value === 'taxRelifFlag') {
                  this.taxRelifFlagnae = taxationTypes[checkFormat.subtract(Number(res.data.resultObj.carShipTax[value]), 1)].text
                  this.taxRelifInfo.hfCode = res.data.resultObj.carShipTax[value]
                } else {
                  if (res.data.resultObj.carShipTax.taxRelifFlag !== '4') {
                    this.taxRelifInfo[value] = res.data.resultObj.carShipTax[value]
                  }
                }
              }
            })
          }
        }
        this.adds = this.adds - 1
      }).catch(error => {
        console.log(error)
        this.adds = this.adds - 1
      })
    },
    // 报价成功返回参数处理
    dealWithDate(res) {
      if (res.data.resultObj.pricingList.length !== 0) {
        this.underwritingProfitRate = res.data.resultObj.pricingList[0].jYUwrel // 核保系数
      }
      const adds = ['extendChar2', 'taxComName', 'taxRelifFlag', 'paidFreeCertificate', 'taxDocumentDate', 'sumPayTax', 'taxPaidAreaCode', 'taxComCode']
      adds.forEach((addEl, index) => {
        if (Object.prototype.hasOwnProperty.call(res.data.resultObj.carShipTax, addEl) && res.data.resultObj.carShipTax[addEl] !== null && res.data.resultObj.carShipTax[addEl] !== '') {
          if (addEl === 'taxRelifFlag') {
            this.taxRelifFlagnae = taxationTypes[checkFormat.subtract(Number(res.data.resultObj.carShipTax[addEl]), 1)].text
            this.taxRelifInfo.hfCode = res.data.resultObj.carShipTax[addEl]
          } else {
            if (res.data.resultObj.carShipTax.taxRelifFlag !== '4') {
              this.taxRelifInfo[addEl] = res.data.resultObj.carShipTax[addEl]
            }
          }
        }
      })
      // 车俩类型编码 2021-6-22
      // const carModelListT = res.data.resultObj.carInfoList
      // if (carModelListT.length > 0) {
      //   this.carModel = true
      //   for (const keys in carModelListT) {
      //     carModelListT[keys].active = false
      //     carModelListT[0].active = true
      //     this.carModelIndex = 0
      //     this.carModelList = carModelListT
      //   }
      // } else if (carModelListT.length === 0) {
      //   this.price = true
      // }
      this.choiceModel()
      const lastYearPolicyInfo = res.data.resultObj.lastYearPolicyInfo
      let counter = 0
      for (const value in lastYearPolicyInfo) {
        if (lastYearPolicyInfo[value] !== '' && lastYearPolicyInfo[value] !== undefined && lastYearPolicyInfo[value] !== null) {
          counter++
        }
        this[value] = lastYearPolicyInfo[value]
      }
      if (counter !== 0) {
        /*
        需求：2021-6-22
        1、报价成功时，当选择的保险起期与上年保险止期未能无缝衔接，则弹框提示上年保单止期
          1.1 交强险、商业险只要一个对不上，就进行提示
          1.2 投交强显示交强，投商业显示商业。都投都显示
        2、若选择得保险起期晚于上年保险止期，且不能无缝衔接，且上年保险止期大于当前日期，则提示（选择好的，自动衔接起止期）
        */
        if (lastYearPolicyInfo.lastEndDate !== '') {
          const dataStr = (this.SYStartDate + ((this.SYStartHour && this.SYStartMinute) ? (' ' + this.SYStartHour + ':' + this.SYStartMinute) : '')).replace(/-/g, '/')
          const data = new Date(dataStr).getTime()
          const datas = new Date(lastYearPolicyInfo.lastEndDate.replace(/-/g, '/')).getTime()
          const now = new Date().getTime()
          if ((!Number.isNaN(data)) && (!Number.isNaN(datas)) && data > datas && datas > now) {
            this.showConfirm = true
            this.joinSy = true
          } else if (data !== datas) {
            this.decide = true
          }
        }
        if (lastYearPolicyInfo.lastEndDateCI !== '') {
          const dataStr = (this.JQStartDate + ((this.JQStartHour && this.JQStartMinute) ? (' ' + this.JQStartHour + ':' + this.JQStartMinute) : '')).replace(/-/g, '/')
          const data = new Date(dataStr).getTime()
          const datas = new Date(lastYearPolicyInfo.lastEndDateCI.replace(/-/g, '/')).getTime()
          const now = new Date().getTime()
          if ((!Number.isNaN(data)) && (!Number.isNaN(datas)) && data > datas && datas > now) {
            this.showConfirmCI = true
            this.joinJq = true
          } else if (data !== datas && !this.showConfirm) {
            this.decideCI = true
          }
        }
      }

      if (this.alter) {
        this.ciProfitDetailData = res.data.resultObj.ciProfitDetailData
      }
      this.SumPayTax = res.data.resultObj.carShipTax.sumPayTax === null ? '0.00' : res.data.resultObj.carShipTax.sumPayTax
      if (res.data.resultObj.basePart.discount && res.data.resultObj.basePart.discount !== '') {
        this.discount = res.data.resultObj.basePart.discount
      } else if (res.data.resultObj.basePart.discount === '' || res.data.resultObj.basePart.discount === null) {
        this.discount = '0.00'
      }
      // 加 驾乘私家车意外险 的保费
      if (this.isShowSJY) {
        this.sumPremium = checkFormat.plus(checkFormat.numDiv(Math.floor(checkFormat.numMulti(Number(res.data.resultObj.basePart.sumPremium), 100)), 100), Number(this.scheme.sumPremium))
      } else {
        this.sumPremium = checkFormat.numDiv(Math.floor(checkFormat.numMulti(Number(res.data.resultObj.basePart.sumPremium), 100)), 100) // 总保费
      }
      // totals动态总保费
      this.totals = checkFormat.numDiv(Math.floor(checkFormat.numMulti(Number(res.data.resultObj.basePart.sumPremium), 100)), 100)
      if (res.data.resultObj.pricingList !== null && res.data.resultObj.pricingList.length > 0) {
        this.pricingScore = res.data.resultObj.pricingList[0].rev_PredScore
        this.revPredScoreAdjust = res.data.resultObj.pricingList[0].revPredScoreAdjust
        this.ncdBpremELR = res.data.resultObj.pricingList[0].ncdBpremELR
        this.lrRecom = res.data.resultObj.pricingList[0].lr_Recom
        this.lrReComAdjust = res.data.resultObj.pricingList[0].lrReComAdjust
      }
      if (this.alter === false) {
        this.SYpremium = '0.00'
      } else {
        res.data.resultObj.planList.forEach(item => {
          if (item.planText === '商业险保费合计') {
            this.SYpremium = item.planFee
          }
        })
      }
      res.data.resultObj.handlingFeeList.forEach(item => {
        if (item.dataType === 'CI') {
          this.JQhandlingFee = item.handlingFeeExcludingTax
        }
        if (item.dataType === 'BI') {
          this.SYhandlingFee = item.handlingFeeExcludingTax
        }
      })
      let sign = 0
      res.data.resultObj.itemKindList.forEach(itemEl => {
        this.insurance.forEach(item => {
          if (item.kindCode === itemEl.kindCode) {
            item.premium = itemEl.premium
          } else {
            item.accessoryRisk.forEach(kind => {
              if (kind.kindCode === itemEl.kindCode) {
                kind.premium = itemEl.premium
              }
            })
          }
        })
        this.moreServeData.forEach(item => {
          if (item.kindCode === itemEl.kindCode) {
            item.premium = itemEl.premium
          }
        })
        if (itemEl.kindCode === 'BZ') {
          this.plusPremium = itemEl.premium
          sign++
        }
        if (itemEl.kindCode === 'B') {
          this.JQinsurance.premium = itemEl.premium
        }
      })
      if (sign === 0) {
        this.JQPremium = '0.00'
      }
      if (counter === 0) {
        Toast.success(res.data.rtnMsg)
      }
      this.hisClaimList = res.data.resultObj.hisClaimList
      this.illegalInfoList = res.data.resultObj.illegalInfoList
      this.already = true
      this.price = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/car/newQuote/Mixin/quoteMixin.js